import React, { FC } from 'react';
import { BookingResource, BookingSlot } from '../../types/booking';
import { ResourceIcon } from './ResourceIcon';
import Button from '../Button';
import { DateTime } from 'luxon';
import { FormattedMessage } from 'react-intl';
import { IconCalendarMinus } from '../icons';
import { SLOT_STYLES } from './slotStyles';
interface Props {
  resource: BookingResource;
  booking: BookingSlot;
  onCancel: (booking: BookingSlot) => void;
}

export const UserBookingItem: FC<Props> = ({ resource, booking, onCancel }) => {
  return (
    <div
      className="flex flex-col p-4 rounded-lg gap-4"
      style={{
        background: SLOT_STYLES.userBooked.color,
        color: SLOT_STYLES.userBooked.textColor,
      }}
    >
      <div className="flex gap-3">
        <ResourceIcon type={resource.type} className="size-10" />
        <div className="flex flex-col justify-center">
          <b>{resource.name}</b>
          <p className="opacity-85">
            {DateTime.fromISO(booking.start).setLocale('sv').toFormat('d MMMM')}{' '}
            {DateTime.fromISO(booking.start).toFormat('HH:mm')} -{' '}
            {DateTime.fromISO(booking.end).toFormat('HH:mm')}
          </p>
        </div>
      </div>
      <Button
        onClick={() => onCancel(booking)}
        className="bg-white !text-gray-900"
      >
        <IconCalendarMinus className="size-5" />
        <FormattedMessage defaultMessage="Avboka" />
      </Button>
    </div>
  );
};
